import React, { FC, useState, useEffect } from "react";

import "./styles.scss";
import CompanyDetailHeader from "./CompanyDetailHeader/CompanyDetailHeader";
import CompanyDetailContent from "./CompanyDetailContent/CompanyDetailContent";
import { useCompany } from "../queryHooks";
import { CustomModalProvider } from "../CustomModalContext/CustomModalContext";
import { ReactQueryDevtools } from 'react-query/devtools'


// import { SagaInjectionModes, useInjectSaga } from "redux-injectors";
// import saga, { joinCompanyRoles } from "../TrixtaComponents/saga";
// import {
//   TrixtaReactionComponent, TrixtaReactionComponentArgs,
//   useTrixtaAction,
// } from "@trixta/trixta-js";
// import { useDispatch } from "react-redux";
// import { login } from "../TrixtaComponents/store/globalActions";
// import CatchTrixtaData from "./CatchTrixtaData";
// import { useParams } from "react-router-dom";
// import { CustomModalProvider } from "../Contexts/CustomModalContext";

interface IProps {
  companyName?: string;
  companyId?: string;
  path?: string;
}

interface Company {
  name?: string;
}

interface CompanyQueryResult {
  data: Company;
  status?: string;
  error?: string;
}

const CompanyDetailPage: FC<IProps> = (props: IProps) => {
  const { companyName } = props;
  //const { id }: { id: string } = useParams();

  // const [wsinited, setWsinited] = useState(false);

  // useEffect(() => {
  //   console.log("${window.location.hostname} :>> ", window.location.hostname);

  //   TimeMe.initialize({
  //     currentPageName: props.companyId + "__" + companyName + "__profile-page", // current page
  //     idleTimeoutInSeconds: 5,
  //     websocketOptions: {
  //       websocketHost: `ws://${window.location.hostname}:8080`,
  //       appId: "psweb",
  //     },
  //   });

  //   TimeMe.callWhenUserLeaves(function () {
  //     let currentTimeOnPage = TimeMe.getTimeOnCurrentPageInSeconds();

  //     console.log("currentTimeOnPage :>> ", currentTimeOnPage);
  //   });

  //   setWsinited(true);
  // }, []);

  // useEffect(() => {
  //   if (!wsinited) {
  //     return;
  //   }

  //   console.log("${window.location.hostname} :>> ", window.location.hostname);

  //   let websocket;
  //   try {
  //     websocket = new WebSocket(`ws://${window.location.hostname}:8080`);
  //   } catch (err) {
  //     console.error(err);
  //   }

  //   console.log("websocket :>> ", websocket);
  // }, [wsinited]);

  // window.onbeforeunload = async function (event) {
  //   let timeSpentOnPage = TimeMe.getTimeOnCurrentPageInSeconds();

  //   console.log("timeSpentOnPage on unload :>> ", timeSpentOnPage);

  //   let response;
  //   response = await axios.post(
  //     "/api/v2/" + "/companies/" + props.companyId + "/profile_analytics"
  //   );
  // };

  const [companyIsLoaded, setCompanyIsLoaded] = useState(false);

  const [companyNotFound, setCompanyNotFound] = useState(false);

  //@ts-ignore
  const {
    data: company = {},
    status: fetchCompanyStatus,
    error: fetchCompanyError,
  } = useCompany({
    companyId: undefined,
    companyName,
  });

  useEffect(() => {
    if (companyName === company.name && fetchCompanyStatus === "success") {
      setCompanyIsLoaded(true);
    }

    if (fetchCompanyStatus === "error") {
      setCompanyNotFound(true);
    }
  }, [companyName, company.name, fetchCompanyStatus]);

  // useInjectSaga({ key: "App", sa

  // const dispatch: Dispatch<SetStateAction<any>> = useDispatch();
  // const debugMode: boolean = false;
  // const companyId: string = id ?? "p12345678";

  /// todo: POC AUTH
  // const onInit = (): void => {
  //   const domain = "paperstreet.space.trixta.io";
  //   const username = "goodson@trixta.com";
  //   const password = "holy11g4659";
  //   dispatch(login({ domainUrl: domain, identity: username, password }));
  //   joinCompanyRoles(companyId, dispatch);
  // };

  // const {
  //   submitTrixtaAction,
  // } = useTrixtaAction({
  //   roleName: `company_info_viewer[${companyId}]`,
  //   actionName: "request_company_info",
  //   options: { debugMode },
  // });

  // useEffect(() => {
  //   onInit();
  // }, []);

  // useEffect(() => {
  //   submitTrixtaAction({ data: {} });
  // }, [submitTrixtaAction]);

  return (
    <div className="ps-company-detail-page">
      <CustomModalProvider>
        <CompanyDetailHeader
          company={company}
          companyIsLoaded={companyIsLoaded}
          companyNotFound={companyNotFound}
        />
      </CustomModalProvider>

      <CompanyDetailContent
        company={company}
        companyIsLoaded={companyIsLoaded}
        companyNotFound={companyNotFound}
      />
      <div className="ps-company-detail-page--y-spacer" />
      <ReactQueryDevtools initialIsOpen={false} />
    </div>
  );
};

export default CompanyDetailPage;

//   return (
//     <div className="container ps-company-detail-page">

//       {/*PUBLIC*/}
//       <TrixtaReactionComponent
//         roleName={`company_info_viewer[${companyId}]`}
//         debugMode={debugMode}
//         requestForEffect={true}
//         reactionName="company_details"
//       >
//         {({
//             data,
//           }: TrixtaReactionComponentArgs<any>) => (
//           <CatchTrixtaData data={{ key: "company", data }} />
//         )}
//       </TrixtaReactionComponent>

//       {/*PRIVATE DATA*/}
//       <TrixtaReactionComponent
//         roleName={`company_info_viewer[${companyId}--private]`}
//         debugMode={debugMode}
//         requestForEffect={true}
//         reactionName="company_details"
//       >
//         {({
//             data,
//           }: TrixtaReactionComponentArgs<any>) => (
//           <CatchTrixtaData data={{ key: "team", data }} />
//         )}
//       </TrixtaReactionComponent>

//       {/*CONFIDENTIAL DATA*/}
//       <TrixtaReactionComponent
//         roleName={`company_info_viewer[${companyId}--confidential]`}
//         debugMode={debugMode}
//         requestForEffect={true}
//         reactionName="company_details"
//       >
//         {({
//             data,
//           }: TrixtaReactionComponentArgs<any>) => (
//           <CatchTrixtaData data={{ key: "confidential", data }} />
//         )}
//       </TrixtaReactionComponent>

//       {/*FIXME: <CustomModalProvider> for POC MetricsModal*/}
//       <CustomModalProvider>
//         <CompanyDetailHeader />
//       </CustomModalProvider>
//       <CompanyDetailContent />
//       <div className="ps-company-detail-page--y-spacer" />
//     </div>
//   );
// };
